import { nullToUndefined } from "common/Support";

export const featureSettingsStorageKey = `glide-feature-settings`;

export function getQuotasKey(appID: string): string {
    return `glide-quotas-${appID}`;
}

export function getTableSizeMapKey(appID: string): string {
    return `${appID}.table-size-map`;
}

export function getPreviewAsKey(appID: string): string {
    return appID + ".preview-as";
}

export function makeAppLoginKey(appID: string): string {
    return `app-login-${appID}`;
}

export function publishedAppKeyForID(appID: string): string {
    return `published-apps-${appID}`;
}

export function getInYourFaceBrandingKey(appID: string): string {
    return `iyfb-${appID}`;
}

export function getAddToHomeKey(appID: string | undefined): string {
    // FIXME: This can be undefined, which could result in some issues
    return appID + "ADDTOHOME";
}

const USER_SUFFIX = ".stored-username";
const PASSWORD_SUFFIX = ".stored-pwd";
const EMAIL_SUFFIX = ".stored-email";
const PASSWORD_FOR_EMAIL_SUFFIX = ".stored-password";
const PIN_SUFFIX = ".pin-sent";

export function getUsernameKey(appID: string): string {
    return appID + USER_SUFFIX;
}

export function getPasswordKey(appID: string): string {
    return appID + PASSWORD_SUFFIX;
}

export function getEmailKey(appID: string): string {
    return appID + EMAIL_SUFFIX;
}

export function getPasswordForEmailKey(appID: string): string {
    return appID + PASSWORD_FOR_EMAIL_SUFFIX;
}

export function getPinKey(appID: string): string {
    return appID + PIN_SUFFIX;
}

export function getAllowLoginSaveKey(appID: string): string {
    return `${appID}.allow-login-save`;
}

function haveLocalStorage(): boolean {
    return localStorage !== null && localStorage !== undefined;
}

export function localStorageGetItem(key: string): string | undefined {
    if (!haveLocalStorage()) return undefined;

    return nullToUndefined(localStorage.getItem(key));
}

export function localStorageSetItem(key: string, value: string): void {
    if (!haveLocalStorage()) return;

    localStorage.setItem(key, value);
}

export function localStorageRemoveItem(key: string): void {
    if (!haveLocalStorage()) return;

    localStorage.removeItem(key);
}
